import React, { Fragment as _ } from 'react';

const AssessmentCorrect = ({ color = '#00D9D3' }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      aria-describedby="title"
    >
      <title>Correct</title>
      <circle
        cx="11"
        cy="11"
        r="10.5"
        style={{
          stroke: color,
        }}
        // stroke="#00D9D3"
      />

      <path
        d="M7.29627 11.6366L10.7257 14.1772L14.9599 8.46152"
        style={{
          stroke: color,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
        // stroke="#00D9D3"
        // stroke-linecap="round"
        // stroke-linejoin="round"
      />
    </svg>
  );
};

export default AssessmentCorrect;
